<template>
  <a
    class="resource"
    :href="item.link"
  >
    <p
      class="resource__title"
      v-html="item.title"
    ></p>
    <div
      class="resource__description"
      v-html="item.description"
    ></div>
  </a>
</template>

<script>
export default {
  name: 'ResourcesItem',
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style lang="scss">
.resource {
  display: block;
  align-self: flex-start;
}

.resource__description {
  margin-bottom: 0;
  color: rgba($primary, 0.65);
}

.resource__title {
  margin-bottom: 12px;

  @media (max-width: $breakpoint-md) {
    margin-bottom: 8px;
  }
}
</style>